import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'


export class HeaderBoxes extends React.PureComponent {
    render() {
        return (
            <div className="head-box-container d-flex flex-wrap justify-content-around w-100 container">
                <div className="head-box-outer ">    
                    <div className="box">
                        <div className="bg-black-padding px-2 py-3">          
                                <div className="head-box mx-2 p-4 d-flex flex-column justify-content-start align-items-center">
                                    <h3>Over Complex</h3>
                              
                                    <p className="text-center">Complex is een Braziliaanse Jiu Jitsu club opgericht in 2018 met als doel de
                                    gevechtskunst die onze levens zo positief beïnvloed heeft te verspreiden. Ben je
                                    geïnteresseerd in zelfverdediging , is jouw doel om aan wedstrijden deel te
                                    nemen en medailles te behalen of wil je gewoon op een leuke manier fit blijven
                                    er is voor iedereen een plaats bij Complex. Onze instructeurs nemen nog actief
                                    deel aan wedstrijden en behaalden al reeds meerdere medailles op nationaal,
                                    Europees en internationaal niveau. </p>
                            
                            </div>
                        </div> 
                    </div>
                </div>
                <div className="head-box-outer ">    
                    <div className="box">
                        <div className="bg-black-padding px-2 py-3">          
                                <div className="head-box head-box-enlarged mx-2 p-4 d-flex flex-column justify-content-start align-items-center">
                                    <h3 className="text-center">Over Braziliaanse Jiu Jitsu</h3>
                                
                                    <p className="text-center">Braziliaanse Jiu Jitsu is een gevechtsport die zich richt op het grondvechten. Men
                                    probeert de tegenstander neer te halen en zich vervolgens steeds naar een
                                    dominantere positie te brengen om de tegenstander uiteindelijk te laten aftikken
                                    door middel van een klem of wurggreep. Jiu Jitsu heeft zijn oorsprong in Japan en
                                    is afgeleid van het Judo. In 1914 bracht Mitsuyo Maeda de sport naar Brazilie
                                    waar één van zijn studenten Helio Gracie bepaalde technieken had aangepast
                                    zodat een kleinere, zwakkere persoon een zwaardere en sterkere tegenstander
                                    zou kunnen verslaan. Die vorm van Jiu Jitsu is wat wij vandaag de dag
                                    Braziliaanse Jiu Jitsu noemen.</p>
                                 
                            </div>
                        </div> 
                    </div>
                </div>
                <div className="head-box-outer ">    
                    <div className="box">
                        <div className="bg-black-padding px-2 py-3">          
                                <div className="head-box mx-2 p-4 d-flex flex-column justify-content-start align-items-center">
                                    <h3>Waar begin ik?</h3>
                                    <p className="text-center">Kom gerust langs voor een gratis proefles. In deze sessie maak je kennis met al de basis vaardigheden die bjj te bieden heeft. Je krijgt namelijk ook de kans om samen te training met echte ervaren atleten. Om te beginnen moet je simpelweg klikken op de knop onderaan en even doorgeven via ons contact formulier tijdens welke training je zal langskomen! </p>
                                    <button  className="button-white"><AnchorLink  className="nav-link text-dark" href='#contact'>Ja ik doe mee!</AnchorLink></button>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        )
    }
}

export default React.memo(HeaderBoxes)
